export default {
    type: 'panel',
    name: 'producer',
    blocks: [
        {
            name: 'eyebrow', // small overline above the title (e.g. "La salaison")
            label: 'Surtitre',
            max: 1,
            type: 'text',
        },
        {
            name: 'title', // rendered as the section <h2>
            label: 'Titre',
            max: 1,
            type: 'text',
        },
        {
            name: 'text', // the story: rich text
            label: 'Texte',
            max: 1,
            type: 'html',
        },
        {
            name: 'image', // producer / building photo
            label: 'Image',
            max: 1,
            type: 'image',
        },
        {
            name: 'highlights', // repeatable key figures (value + label), e.g. "+80 ans" / "de savoir-faire"
            label: 'Chiffres clés',
            type: 'mixed',
            blocks: [
                {
                    name: 'value',
                    label: 'Valeur',
                    max: 1,
                    type: 'text',
                },
                {
                    name: 'label',
                    label: 'Libellé',
                    max: 1,
                    type: 'text',
                },
            ],
        },
        {
            name: 'linkLabel', // optional CTA label (e.g. "Découvrir la salaison")
            label: 'Libellé du lien',
            max: 1,
            type: 'text',
        },
        {
            name: 'linkUrl', // optional CTA target (relative path)
            label: 'URL du lien',
            max: 1,
            type: 'text',
        },
    ],
};
